import React from 'react';
import { Search } from 'lucide-react';
import CustomInput from '../../../../components/forms/CustomInput';
import CustomDatePicker from '../../../../components/forms/CustomDatePicker';

const TrackingSearchBox = ({
  fields = [],
  onSubmit,
  buttonText = 'Track',
  loading = false,
  disabled = false
}) => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8">
      <form onSubmit={onSubmit} className="flex flex-col md:flex-row gap-4 md:items-end">
        {fields.map((field, idx) => (
          <div key={idx} className="flex-1 w-full">
            {field.type === 'date' || field.isDate ? (
              <div>
                {field.label && (
                  <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5">
                    {field.label}
                  </label>
                )}
                <CustomDatePicker
                  value={field.value}
                  onChange={field.onChange}
                  placeholder={field.placeholder || "Select date"}
                  className="w-full"
                  inputClassName="rounded-xl border-slate-200 bg-slate-50 focus:bg-white focus:border-primary focus:ring-primary text-slate-800"
                />
              </div>
            ) : (
              <CustomInput
                label={field.label}
                placeholder={field.placeholder}
                value={field.value}
                onChange={field.onChange}
                icon={field.icon}
                type={field.type || 'text'}
                className="w-full"
                inputClassName="rounded-xl border-slate-200 bg-slate-50 focus:bg-white focus:border-primary focus:ring-primary text-slate-800"
              />
            )}
          </div>
        ))}
        <button
          type="submit"
          disabled={disabled || loading}
          className="w-full md:w-auto px-6 py-3 bg-primary text-white font-semibold rounded-xl hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-primary/20 flex items-center justify-center gap-2 h-[42px] cursor-pointer active:scale-95 shrink-0"
        >
          {loading ? (
            <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
          ) : (
            <>
              <Search size={18} /> {buttonText}
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default TrackingSearchBox;
